<template>
  <div class="w-full px-6 py-4">
    <o-field-group
      class="w-full mb-12 block"
      :label="$t('components.voucher.edit.employee.onlineBookingURL')"
      :info="$t('components.voucher.edit.employee.urlInfo')"
    >
      <div class="w-full p-3 border rounded-md bg-gray-50 mt-3 relative dark:bg-gray-900">
        <input ref="booking" type="text" :value="`https://${$auth.info.location.slug}.${bookappDomain}/book-now?voucher=${_voucher.code}`" class="bg-transparent w-full font-medium text-center text-blue-600 text-md">

        <o-button
          ref="button-booking"
          flat
          icon="copy"
          class="absolute right-0 top-1/2 transform -translate-y-1/2 mr-2"
          @click="handleCopy('booking')"
        />
      </div>
    </o-field-group>

    <o-field-group
      class="w-full mb-12 block"
      :label="$t('components.voucher.edit.employee.onlineBookingTimetableURL')"
      :info="$t('components.voucher.edit.employee.urlInfo')"
    >
      <div class="w-full p-3 border rounded-md bg-gray-50 mt-3 relative dark:bg-gray-900">
        <input ref="timetable" type="text" :value="`https://${$auth.info.location.slug}.${bookappDomain}/timetable?voucher=${_voucher.code}`" class="bg-transparent w-full font-medium text-center text-blue-600 text-md">

        <o-button
          ref="button-timetable"
          flat
          icon="copy"
          class="absolute right-0 top-1/2 transform -translate-y-1/2 mr-2"
          @click="handleCopy('timetable')"
        />
      </div>
    </o-field-group>

    <o-field-group
      class="w-full"
      :label="$t('components.voucher.edit.employee.onlineBookingLastMinuteURL')"
      :info="$t('components.voucher.edit.employee.urlInfo')"
    >
      <div class="w-full p-3 border rounded-md bg-gray-50 mt-3 relative dark:bg-gray-900">
        <input ref="lastminute" type="text" :value="`https://${$auth.info.location.slug}.${bookappDomain}/last-minute?voucher=${_voucher.code}`" class="bg-transparent w-full font-medium text-center text-blue-600 text-md">

        <o-button
          ref="button-lastminute"
          flat
          icon="copy"
          class="absolute right-0 top-1/2 transform -translate-y-1/2 mr-2"
          @click="handleCopy('lastminute')"
        />
      </div>
    </o-field-group>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

interface Props {
  voucher: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:voucher', value: Record<string, any>): void
}>()

const instance = getCurrentInstance()

const bookappDomain = computed(() => {
  return (instance?.proxy as any)?.$config?.public?.bookappDomain
})

const _voucher = computed({
  get () {
    return props.voucher
  },
  set (value) {
    emit('update:voucher', value)
  },
})

function handleCopy (refName: string) {
  try {
    const $el = (instance?.proxy as any)?.$refs[refName]

    $el.select()
    $el.setSelectionRange(0, 99999)

    navigator.clipboard.writeText($el.value)

    const button = (instance?.proxy as any)?.$refs['button-' + refName]

    button.icon = 'check'
    button.variant = 'success'
  } catch (e) {
    console.log(e)
  }
}
</script>
